import { useEffect, useState } from "react";

import Box from "@mui/material/Box";

import Spinner from "@components/Animations/Spinner";
import Alert from "@components/Popups/Alert";
import BlockingModal from "@components/Popups/BlockingModal";
import Confirmation from "@components/Popups/Confirmation";
import Modal from "@components/Popups/Modal";
import Notification from "@components/Popups/Notification";

import { initializeSentry } from "@hooks/useBrowserMonitoring";

import Router from "./Router";
import UserService from "./services/user.service";

initializeSentry();

// Test

/**
 * The root component for the application.
 */
const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const checkAuthentication = async () => {
      await UserService.isAuthenticated();
      setIsLoaded(true);
    };

    checkAuthentication();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {isLoaded ? <Router /> : <Spinner sx={{ mt: 4 }} />}
      <Notification />
      <Confirmation />
      <Modal />
      <BlockingModal />
      <Alert />
    </Box>
  );
};

export default App;
